import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const Tag = styled.div`
  ${({ tag }) =>
    css`
      background: ${tag?.bgColor};
      ${({ theme }) => theme.fontFamily.secondaryFont.xxSmallBold}
      color: ${tag?.text?.color};
      border-radius: ${({ theme, rounded }) =>
        rounded ? theme.spacing(2, 5, 5, 2) : theme.spacing(0, 4, 4, 0)};
      padding: 4px 8px;
      margin-bottom: 4px;
    `}
`;

function ProductTag({ tag }) {
  const { text, bgColor } = tag;
  if (!bgColor) return null;

  return (
    <Tag tag={tag} className="shop_card_tag">
      {text.text}
    </Tag>
  );
}

ProductTag.propTypes = {
  tag: PropTypes.shape({
    bgColor: PropTypes.string,
    text: PropTypes.shape({
      text: PropTypes.string,
      font: PropTypes.string,
      size: PropTypes.number,
      color: PropTypes.string,
    }),
  }),
};

export default ProductTag;
